import { types } from "./mutations";

export default {
  /**
   * Loads the initial controls into the state
   */
  loadControls: async ({ commit }, { controls }) => {
    commit(types.SET_CONTROLS, controls);
  },

  /**
   * Loads the initial flagsets into the state
   */
  loadFlags: async ({ commit }, { flags }) => {
    commit(types.SET_FLAGS, flags);
  },

  /**
   * Change a control item
   */
  changeControl: async ({ commit, state }, { key, value }) => {
    commit(types.SET_CONTROLS, {
      ...state.controls,
      [key]: value,
    });
  },

  /**
   * Change a flag
   */
  changeFlag: async ({ commit, state }, { key, value }) => {
    commit(types.SET_FLAGS, {
      ...state.flags,
      [key]: value,
    });
  },

  /**
   * Toggle a flag
   */
  toggleFlag: async ({ commit, state }, { key }) => {
    commit(types.SET_FLAGS, {
      ...state.flags,
      [key]: !state.flags[key],
    });
  },
};
